import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const monthNames = {
  en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  tr: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
  ar: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
};

export const formatDateByLanguage = (date: Date, language: 'en' | 'tr' | 'ar'): string => {
  const month = monthNames[language][date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  
  if (language === 'ar') {
    return `${day} ${month} ${year}`;
  }
  
  return `${month} ${day}, ${year}`;
};

/**
 * Transforms a Supabase storage URL to use the image transformation API
 * for responsive, optimized image delivery
 */
export function getOptimizedImageUrl(url: string, width: number, height?: number): string {
  if (!url) return url;
  
  // Check if it's a Supabase storage URL
  const supabaseStoragePattern = /supabase\.co\/storage\/v1\/object\/public\//;
  if (!supabaseStoragePattern.test(url)) return url;
  
  // Transform to use render/image endpoint
  const transformedUrl = url.replace(
    '/storage/v1/object/public/',
    '/storage/v1/render/image/public/'
  );
  
  // Add width parameter, and height if provided
  const params = new URLSearchParams();
  params.append('width', width.toString());
  if (height) params.append('height', height.toString());
  
  return `${transformedUrl}?${params.toString()}`;
}

/**
 * Generates srcset for responsive images
 */
export function getImageSrcSet(url: string, sizes: { width: number; height?: number }[]): string {
  if (!url) return '';
  
  return sizes
    .map(({ width, height }) => {
      const optimizedUrl = getOptimizedImageUrl(url, width, height);
      return `${optimizedUrl} ${width}w`;
    })
    .join(', ');
}
